import React from 'react';

// Components
import LandingPageCTAButton from 'shared/components/LandingPageCTA/LandingPageCTAButton';
import CopyLinkButton from 'shared/components/LandingPageCTA/CopyLinkButton';
import { mixpanelEvents, mixpanelTrack } from 'utils/mixpanelHelpers';

const {
  webinars: { CLICK_BOOK_SESSION },
} = mixpanelEvents;

const bookBtn = (webinar) => ({
  component: LandingPageCTAButton,
  props: {
    text: 'Book a Session',
    link: '/book',
    onClick: () => {
      mixpanelTrack(CLICK_BOOK_SESSION, {
        encodedId: webinar.encodedId,
        name: webinar.name,
        cta: 'Book a Session',
      });
    },
  },
});

const returnHomeBtn = {
  component: LandingPageCTAButton,
  props: {
    text: 'Return Home',
    link: '/home',
  },
};

const redirectToWebinarBtn = (webinar) => ({
  component: LandingPageCTAButton,
  props: {
    text: 'Return to Course',
    link: `webinars/${webinar.encodedId}`,
  },
});

export const getPageContent = (webinar = {}) => ({
  bookCtaProps: {
    copy: 'Want to talk to a coach?',
    button: bookBtn(webinar),
  },
  shareCtaProps: {
    copy: 'Want to share this webinar?',
    button: {
      component: CopyLinkButton,
      props: {
        text: 'Copy Link',
        link: location.href.split('?')[0],
        onClick: () => {
          mixpanelTrack(CLICK_BOOK_SESSION, {
            encodedId: webinar.encodedId,
            name: webinar.name,
            CTA: 'Copy Link',
          });
        },
      },
    },
  },
});

const POST_SURVEY_THANK_YOU = 'Thank you! Your survey has been submitted.';

const POST_SURVEY_THANK_YOU_WITH_CTA_MSG_FOR_NO_UPCOMING_SESSIONS = (
  <>
    {POST_SURVEY_THANK_YOU}
    <br />
    <br />
    Want to build upon what you just learned? Schedule a session with a Bravely
    coach
  </>
);

const POST_SURVEY_THANK_YOU_WITH_CTA_MSG_FOR_UPCOMING_SESSIONS = (
  <>
    {POST_SURVEY_THANK_YOU}
    <br />
    <br />
    Want more webinars? View recordings of all of our past webinars in the
    Bravely Library.
  </>
);

export const getPostSurveyCtaProps = ({
  webinar,
  hasUpcomingSession,
  isLiveTraining,
}) => {
  let copy = '';
  let buttonProps;
  if (isLiveTraining && hasUpcomingSession) {
    copy = POST_SURVEY_THANK_YOU_WITH_CTA_MSG_FOR_UPCOMING_SESSIONS;
    buttonProps = redirectToWebinarBtn(webinar);
  } else if (hasUpcomingSession) {
    copy = POST_SURVEY_THANK_YOU;
    buttonProps = returnHomeBtn;
  } else {
    copy = POST_SURVEY_THANK_YOU_WITH_CTA_MSG_FOR_NO_UPCOMING_SESSIONS;
    buttonProps = bookBtn(webinar);
  }

  return {
    copy,
    button: buttonProps,
  };
};
